// extracted by mini-css-extract-plugin
export default {"map":"ObjectMap_map__JwVwO","decorImg":"ObjectMap_decorImg__7lufM"};